export namespace Media {
    /**
     * Endpoint path
     */
    export interface IConfig {
        brightcove?: {
            accountId: string;
            playerId: string;
        };
    }

    export enum Events {
        play = 'player.play.request',
        pause = 'player.pause.request',
        stop = 'player.stop.request'
    }
}
